module.exports = __webpack_public_path__ + "img/cloud-minus-fill.ff17f465.svg";